import { useEffect } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import * as am4maps from "@amcharts/amcharts4/maps";
import am4geodata_worldIndiaLow from "@amcharts/amcharts4-geodata/worldIndiaLow";
import * as am4charts from "@amcharts/amcharts4/charts";
import styles from "./PortsChart.module.scss";
import LoadingSkeleton from "../../../shared/LoadingSkeleton/index.jsx";
import NoSearchDataComponent from "../../../shared/country-components/no-search-data.js";

am4core.useTheme(am4themes_animated);
am4core.addLicense("ch-custom-attribution");
// Define marker path
let targetSVG = "M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M9,15.93 c-3.83,0-6.93-3.1-6.93-6.93S5.17,2.07,9,2.07s6.93,3.1,6.93,6.93S12.83,15.93,9,15.93 M12.5,9c0,1.933-1.567,3.5-3.5,3.5S5.5,10.933,5.5,9S7.067,5.5,9,5.5 S12.5,7.067,12.5,9z";
const PortsChart = ({ mapData = [], loading = false, error = false }) => {
  useEffect(() => {
    const chart = am4core.create("countrychartdiv", am4maps.MapChart);
    if (!loading && !error) {
      createChart(chart);
    }

    return () => {
      if (chart) {
        chart.dispose();
      }
    };
  }, [loading, error, mapData]);

  const createChart = (chart) => {
    chart.geodata = am4geodata_worldIndiaLow;
    // Create map polygon series
    chart.projection = new am4maps.projections.Mercator();
    let polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());
    polygonSeries.useGeodata = true;
    let polygonTemplate = polygonSeries.mapPolygons.template;
    polygonTemplate.fill = am4core.color("#D3D3D3");
    polygonSeries.exclude = ["AQ"];
    polygonSeries.mapPolygons.template.nonScalingStroke = true;

    // Create image series
    let imageSeries = chart.series.push(new am4maps.MapImageSeries());

    // Create a circle image in image series template so it gets replicated to all new images
    let imageSeriesTemplate = imageSeries.mapImages.template;
    let circle = imageSeriesTemplate.createChild(am4core.Circle);
    circle.radius = 6;
    circle.fill = am4core.color("#7143f1");
    circle.stroke = am4core.color("#FFFFFF");
    circle.strokeWidth = 3;
    circle.nonScaling = true;

    // Set property fields
    imageSeriesTemplate.propertyFields.latitude = "latitude";
    imageSeriesTemplate.propertyFields.longitude = "longitude";

    // Zoom control
    chart.zoomControl = new am4maps.ZoomControl();

    let homeButton = new am4core.Button();
    homeButton.events.on("hit", function () {
      chart.goHome();
    });

    homeButton.icon = new am4core.Sprite();
    homeButton.padding(7, 5, 7, 5);
    homeButton.width = 30;
    homeButton.icon.path = "M16,8 L14,8 L14,16 L10,16 L10,10 L6,10 L6,16 L2,16 L2,8 L0,8 L8,0 L16,8 Z M16,8";
    homeButton.marginBottom = 10;
    homeButton.parent = chart.zoomControl;
    homeButton.insertBefore(chart.zoomControl.plusButton);

    // Center on the groups by default
    chart.homeZoomLevel = 1;
    chart.homeGeoPoint = { longitude: 5, latitude: 20 };

    // Add images
    let imageTemplate = imageSeries.mapImages.template;
    imageTemplate.tooltipText = "{title}";
    imageTemplate.nonScaling = true;

    imageTemplate.adapter.add("tooltipHTML", (text, target) => {
      let data = target.tooltipDataItem.dataContext;
      if (data && data.shipments > 0) {
        return '<span className="d-flex align-items-center" style="font-size: 14px;">{title} <br/>{shipments} shipments</span>';
      } else {
        return text;
      }
    });

    imageSeries.tooltip.getFillFromObject = false;
    imageSeries.tooltip.label.fill = "#000";
    imageSeries.tooltip.background.fill = "#fff";
    imageSeries.tooltip.background.stroke = "#eaecf0";

    let marker = imageTemplate.createChild(am4core.Sprite);
    marker.path = targetSVG;
    marker.horizontalCenter = "middle";
    marker.verticalCenter = "middle";
    marker.propertyFields.scale = "scale";
    marker.fill = am4core.color("#7143f1");

    imageTemplate.propertyFields.latitude = "latitude";
    imageTemplate.propertyFields.longitude = "longitude";
    imageSeries.data = mapData;

    if (chart.logo) {
      chart.logo.disabled = true;
    }

    chart.cursor = new am4charts.XYCursor();
  };

  return (
    <>
      <div id="countrychartdiv" style={{ width: "100%", display: loading && "none" }} className={styles.portsChartContainer} />
      {loading ? <LoadingSkeleton shape={"square"} height={"100%"} width={"100%"} margin={"1rem 1rem 0 0"} /> : error ? <NoSearchDataComponent className={styles.noSearchDataContainer} content={"Unable to fetch the data at current moment."} /> : null}
    </>
  );
};

export default PortsChart;
